import React from "react";

const HeaderHomeIcon = ({ className, fill = "var(--color-primary)" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="20"
		viewBox="0 0 21 20"
		fill="none"
		className={className}
	>
		<path
			d="M9.83435 0.265555C10.0178 0.0944833 10.2546 0 10.5 0C10.7454 0 10.9822 0.0944833 11.1656 0.265555L20.188 8.68693C20.3766 8.87506 20.4881 9.13281 20.4991 9.40572C20.5101 9.67863 20.4196 9.94534 20.2468 10.1495C20.074 10.3537 19.8323 10.4793 19.5729 10.4998C19.3135 10.5204 19.0567 10.4342 18.8567 10.2596L18.5198 9.94698V17.8947C18.5198 18.453 18.3086 18.9885 17.9326 19.3834C17.5566 19.7782 17.0466 20 16.5149 20H4.48512C3.95338 20 3.44341 19.7782 3.0674 19.3834C2.6914 18.9885 2.48017 18.453 2.48017 17.8947V9.94698L2.14333 10.2596C1.9433 10.4342 1.68645 10.5204 1.42706 10.4998C1.16767 10.4793 0.926039 10.3537 0.753218 10.1495C0.580397 9.94534 0.489917 9.67863 0.500894 9.40572C0.51187 9.13281 0.623442 8.87506 0.81204 8.68693L9.83435 0.265555ZM4.48512 8.07322V17.8947H7.49256C7.49256 17.8947 12.5833 17.8947 13.5074 17.8947C14.4315 17.8947 16.5149 17.8947 16.5149 17.8947V8.07428L10.5 2.46038L4.48512 8.07322Z"
			fill={fill}
		/>
	</svg>
);

export default HeaderHomeIcon;
